export const hrEmployeeSalaryeApi = {
    heading:[
        {
            head:"Name"
        },
        {
            head:"ID"
        },
        {
            head:"Email"
        },
        {
            head:"Department"
        },
        {
            head:"Role"
        },
        {
            head:"Salary"
        },
        {
            head:"Status"
        },
        {
            head:"Pay Slip"
        },
        {
            head:"Action"
        },
    ],
    data:[
        {
            name:"akib",
            id:"46546",
            email:"abc@gmail.com",
            department:"Academic",
            role:"Teacher",
            salary:"25000",
            status:"Not Paid",
            payslip:"./assets/images/dashboards/adminDashboard/HR/icons/downicon.png",
            action:{
                edit:"./assets/images/dashboards/adminDashboard/HR/icons/editicon.png",
                cross:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
            }
        },
        {
            name:"akib",
            id:"46546",
            email:"abc@gmail.com",
            department:"Academic",
            role:"Teacher",
            salary:"25000",
            status:"Paid",
            payslip:"./assets/images/dashboards/adminDashboard/HR/icons/downicon.png",
            action:{
                edit:"./assets/images/dashboards/adminDashboard/HR/icons/editicon.png",
                cross:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
            }
        },
        {
            name:"akib",
            id:"46546",
            email:"abc@gmail.com",
            department:"Academic",
            role:"Teacher",
            salary:"25000",
            status:"Pending",
            payslip:"./assets/images/dashboards/adminDashboard/HR/icons/downicon.png",
            action:{
                edit:"./assets/images/dashboards/adminDashboard/HR/icons/editicon.png",
                cross:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
            }
        },
      
    ]
}